import React from 'react';


const Footer = () => {
  return (
    <div className='footer'>
      <h3 className='copyright'>&copy;2020 - Kildon Veseli</h3>
    </div>
  );
}

export default Footer;